
export default {
  name: 'BrandReviewsTop',
  props: {
    sortMode: {
      type: String,
    },
    rating: {
      type: Object,
    },
  },
  data: () => ({
    sortVariants: [
      { text: 'Includes Photos', value: 'by_customer_photos' },
      { text: 'Latest', value: 'by_date' },
      { text: 'Most Relevant', value: 'by_most_relevant' },
      { text: 'Most Helpful', value: 'by_helpful' },
    ],
  }),
  computed: {
    ratingCount() {
      return `${this.rating.count.toLocaleString('en-US')} ${this.count === 1
        ? 'review' : 'reviews'}`;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    menuClassString() {
      return this.isBoutiquePage ? 'is_boutique' : '';
    },
    starColor() {
      return (process.client && window.innerWidth >= 1264)
        ? this.$cp.primary_support_darker1
        : this.$cp.primary_support;
    },
    selectSort() {
      return this.sortVariants.find((v) => v.value === this.sortMode);
    },
    formattedSortVariants() {
      if (this.rating?.hasImages) {
        return this.sortVariants;
      }
      return this.sortVariants.filter((v) => v.value !== 'by_customer_photos');
    },
  },
  methods: {
    changeSort(select) {
      if (select.value === this.sortMode) {
        return;
      }
      this.$emit('change-sort', select.value);
    },
  },
};
